import { render } from "./main_rental.vue?vue&type=template&id=3b134ec8&scoped=true"
import script from "./main_rental.vue?vue&type=script&lang=js"
export * from "./main_rental.vue?vue&type=script&lang=js"

import "./main_rental.vue?vue&type=style&index=0&id=3b134ec8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b134ec8"]])

export default __exports__